import { Theme, useInert } from '@infotech-soe/erp-ui-kit';
import React, { useRef } from 'react';
import { createUseStyles } from 'react-jss';

import ActivePanelManagerContainer from '../category/ActivePanelManagerContainer';
import ContentTabsContainer from '../content/ContentTabsContainer';
import CommandConfirmationDialogContainer from '../dialogs/CommandConfirmationDialogContainer';
import ActiveDictionariesContainer from '../dictionary/ActiveDictionariesContainer';
import ActiveFormsContainer from '../form/ActiveFormsContainer';
import DocLinksGraphDialogContainer from '../graph/DocLinksGraphDialogContainer';
import PivotReportDialogContainer from '../pivot-report/PivotReportDialogContainer';
import PrivsDialog from '../privs/PrivsDialog';
import ReviewContainer from '../review/ReviewContainer';
import SignFormContainer from '../sign/SignFormContainer';
import WorkTableDialog from '../work-table/WorkTableDialog';

const useStyles = createUseStyles(({ sizes, colors }: Theme) => ({
  container: {
    composes: 'full-height',
    marginLeft: sizes.applicationMenu.width,
    padding: sizes.dataviewPane.padding,
    backgroundColor: colors.backgroundPanelActive,
  },
}));

interface Props {
  isShowConfirmation: boolean;
}

const DataviewPane = ({ isShowConfirmation }: Props): React.JSX.Element => {
  const classes = useStyles();
  const dataviewPaneRef = useRef<HTMLDivElement>(null);
  useInert(dataviewPaneRef.current, isShowConfirmation);

  return (
    <div className={classes.container} ref={dataviewPaneRef}>
      <ActivePanelManagerContainer>
        <ContentTabsContainer />
        <ActiveFormsContainer />
        <ActiveDictionariesContainer />
        <CommandConfirmationDialogContainer />
        <WorkTableDialog />
        <DocLinksGraphDialogContainer />
        <PrivsDialog />
        <PivotReportDialogContainer />
        <ReviewContainer />
        <SignFormContainer />
      </ActivePanelManagerContainer>
    </div>
  );
};

export default DataviewPane;
